import { CallToAction } from '@/graphql/types';
import { CTAMapper } from '@/pages/FlyerDetails/CtaMapper';

// A link the app can't label or open is hidden rather than shown as something else.
export default function isValidCta(cta?: CallToAction | null): boolean {
  if (!cta || !CTAMapper[cta.type] || !cta.value) return false;
  return cta.type !== 'sms' || /^sms:/i.test(cta.value);
}
